import { queryOptions, useQuery } from '@tanstack/vue-query'

// Global SEO defaults from /public/settings/seo. SSR-only: rendered into the
// document head, no client refetch needed.
export const seoSettingsQuery = queryOptions({
  queryKey: ['settings', 'seo'],
  retry: 0,
  staleTime: 1000 * 60 * 30,
  queryFn: async ({ signal }: { signal?: AbortSignal }) => {
    const { get } = useApi()
    return await get<SeoSettings>('/public/settings/seo', undefined, { signal })
  },
  select: (res) => ({
    prefix: res?.data?.seo_title_prefix?.value || '',
    suffix: res?.data?.seo_title_suffix?.value || '',
    description: res?.data?.seo_title_description?.value || '',
    keywords: res?.data?.seo_title_keywords?.value || '',
  }),
})

export function useSeoSettings() {
  return useQuery(seoSettingsQuery)
}
